import React from 'react'
import { Link } from 'react-router-dom'

const Siniestros = () => {
      return (
      <>
         <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
               <h5><b>SINIESTROS</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Formulario de Denuncia de Accidente de Trabajo o Enfermedad Profesional (PDF)</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/FormularioDeDenunciadeSiniestrosARTLatitudSurSA.pdf`} className="btn btn-large waves-effect waves-light bg-latitud pulse" type="submit" name="action">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Formulario de Denuncia de Accidente de Trabajo o Enfermedad Profesional (EXCEL)</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/FormularioDeDenunciasARTLatitudSur.xlsx`} className="btn btn-large waves-effect waves-light bg-latitud pulse" type="submit" name="action">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Instructivo para Completar el Formulario de Denuncia</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a rel="noopener noreferrer" href={`${process.env.REACT_APP_API_URL}/web/download/InstructivoCompletarFormularioDeDenuncia.pdf`} className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
      </>
      )
}

export default Siniestros